import { Role } from './constants/enum'
import {
  adminRoutes,
  hrRoutes,
  managerRoutes,
  memberRoutes,
} from './navigation'

export const getRoutesBasedOnUserRole = (role: string) => {
  if (role === Role.Admin) {
    return adminRoutes
  } else if (role === Role.Manager) {
    return managerRoutes
  } else if (role === Role.HR) {
    return hrRoutes
  }
  return memberRoutes
}
